(function () {
    'use strict';

    angular.module("imApp").factory("travelWageDataService", ['$ihttp', function ($ihttp) {
        let service = {
            getTravelWageData: function (parms) {
                return $ihttp.post({
                    method: 1259,
                    parameters: parms || {}
                });
            },
            listTravelWageTypes: function (parms) {
                return $ihttp.post({
                    method: 1261,
                    parameters: parms || {}
                });
            },
            listTravelWages: function (parms) {
                return $ihttp.post({
                    method: 1260,
                    parameters: parms || {}
                });
            },
            travelWageChanged: function (parms) {
                return $ihttp.post({
                    method: 1263,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1262,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
